import { render } from "./SheetImageCatalogueComponent.vue?vue&type=template&id=24b5cc2b&scoped=true"
import script from "./SheetImageCatalogueComponent.vue?vue&type=script&lang=js"
export * from "./SheetImageCatalogueComponent.vue?vue&type=script&lang=js"

import "./SheetImageCatalogueComponent.vue?vue&type=style&index=0&id=24b5cc2b&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b5cc2b"]])

export default __exports__